import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/apiClient';
import '../css/OtpVerify.css';
import { AppContext } from '../context/AppContext';
import { toast } from "react-toastify";

const OtpVerify = () => {
  const navigate = useNavigate();
  const { user, userPin, mobileNo, password, setUser } = useContext(AppContext);

  const [enteredPassword, setEnteredPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Ensure password exists in context
  useEffect(() => {
    if (!password) {
      toast.error('Password not found. Please create account again.');
      navigate('/create-account', { replace: true });
    }
  }, [password, navigate]);

  // ✅ Verify Password and complete registration
  const handleVerify = async () => {
    if (!enteredPassword.trim()) {
      toast.warn('Please enter your password');
      return;
    }

    if (enteredPassword !== password) {
      toast.error('Incorrect password. Please try again.');
      return;
    }

    setIsLoading(true);

    try {
      // REGISTER (password based)
      const registerRes = await apiClient.post('/user-register', {
        fullName: user,
        mobileNo,
        password: password,
        password_confirmation: password,
        security_pin: parseInt(userPin),
      });

      if (registerRes?.data?.status === true) {
        const { accessToken, registerId } = registerRes.data.info;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('registerId', registerId);

        // FETCH PROFILE (auth route)
        const profileRes = await apiClient.post(
          '/user-details-by-register-id',
          { registerId }
        );

        if (profileRes?.data?.status === true && profileRes.data.info) {
          const userInfo = profileRes.data.info;

          localStorage.setItem('userProfile', JSON.stringify(userInfo));
          localStorage.setItem('walletBalance', userInfo.walletBalance);

          setUser(userInfo);

          navigate("/home", { replace: true });
        } else {
          toast.warn('Registration successful, but failed to load your profile.');
          navigate("/login-with-mpin", { replace: true });
        }
      } else {
        toast.error(registerRes?.data?.msg || 'Registration failed.');
      }
    } catch (err) {
      console.error('Verify error:', err?.response || err);
      toast.error('Something went wrong. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">

      <div className="top-header">
        VERIFY YOUR MOBILE NUMBER
      </div>

      <div className="otp-container">
        <div className='llll'>

          <div className="otp-subtext">
            <h3>Enter Password</h3>
            <p>Enter your password to verify and complete registration</p>
            <p className="otp-number">{mobileNo}</p>
          </div>

          <input
            type="password"
            className="otp-input"
            placeholder="Enter Password"
            value={enteredPassword}
            onChange={(e) => setEnteredPassword(e.target.value)}
          />

          <button className="otp-button" onClick={handleVerify}>
            {isLoading ? 'VERIFYING...' : 'VERIFY'}
          </button>

        </div>
      </div>
    </div>
  );
};

export default OtpVerify;